import { createFileRoute } from '@tanstack/react-router'
import UsersAdminPage from '@/pages/UsersAdminPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/admin/users/')({
    component: UsersAdminPage,
})